export const LOCAL_STORAGE_KEY_LOGGED_ADMIN = 'logged_admin';
export const LOCAL_STORAGE_KEY_LOGGED_ADMIN_TOKEN = 'logged_admin_token';
